import type {ReactElement} from 'react';
import {StylePresetSelectorControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/style-preset-selector-control/style-preset-selector-control';
import {BORDER_WIDTH_PRESETS} from '@FormMakerReact/layout/form-maker-right-panel/sectors/submit-button-presets';
import type {SubmitButtonBorderWidthControlProps} from './submit-button-border-width-control.types';

export function SubmitButtonBorderWidthControl({component}: SubmitButtonBorderWidthControlProps): ReactElement {
  return <StylePresetSelectorControl component={component} property="border-width" labelKey="pmwjs_form_maker_control_border_label" presets={BORDER_WIDTH_PRESETS} />;
}
